<details-section title="Skills" [showDetails]="false">
  <div class="container" [formGroup]="form">
    <div [formGroup]="skillPromptGroup">
      <qai-field [label]="skillPromptLabel">
        <textarea
          qai-textarea
          autosize
          qaiPasteClean
          [maxLines]="30"
          qaiTrimLeading
          formControlName="promptText"
        ></textarea>
      </qai-field>
    </div>
  </div>
</details-section>
